import { Component, OnInit } from '@angular/core';
import {
  sortByDate,
  sortCaseInsensitive,
} from '../../../core/pure-functions/grids/grid-sorting-helper';
import { Observable } from 'rxjs';
import { CharterDAO } from '../../../core/services/dao/charterDAO';

@Component({
  selector: 'app-broker',
  templateUrl: './broker.component.html',
  styleUrls: ['./broker.component.scss'],
})
export class BrokerComponent implements OnInit {
  colDefs: any[];
  data$: Observable<BrokerCharterGridItem[]>;

  constructor(private charterDAO: CharterDAO) {}

  ngOnInit() {
    this.colDefs = this.createColumnDefs();
    this.data$ = this.charterDAO.getBrokerCharters();
  }

  createColumnDefs() {
    return [
      {
        headerName: 'ID',
        field: 'id',
        filter: 'text',
        comparator: sortCaseInsensitive,
      },
      {
        headerName: 'Charter Date',
        field: 'charterDate',
        filter: 'date',
        sort: 'asc',
        comparator: sortByDate,
      },
      {
        headerName: 'Created At',
        field: 'createdAt',
        filter: 'date',
        comparator: sortByDate,
      },
      {
        headerName: 'Status',
        field: 'status',
        filter: 'text',
        comparator: sortCaseInsensitive,
      },
    ];
  }
}

export interface BrokerCharterGridItem {
  id: number;
  charterDate: Date;
  createdAt: Date;
  status: string;
}
